const validationStepUrls = {
  illustrations: {
    pending:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773235728/corp-management-ui/balance/validation-pending_png.png',
    inReview:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773670629/corp-management-ui/balance/validation-in-review_png.png',
    rejected:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773670629/corp-management-ui/balance/validation-rejected_png.png',
    approved:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773670629/corp-management-ui/balance/validation-approved_png.png',
  },
  termsOfService: 'https://www.getbalance.com/legal/end-user-terms/',
  icons: {
    lock: 'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773670804/corp-management-ui/balance/icon-shield-lock_png.png',
    check:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1773670804/corp-management-ui/balance/icon-shield-check_png.png',
  },
} as const;

export const statesContent = {
  pending: {
    illustrationUrl: validationStepUrls.illustrations.pending,
    title: 'Financial information',
    termsOfServiceLinkText: 'Balance Terms of Service',
    termsOfServiceLinkUrl: validationStepUrls.termsOfService,
    text: [
      "Next, you'll be securely redirected to our payments partner, Balance, to provide your financial details and select your preferred payment method. By proceeding to the secure Balance window, you agree to the",
      ", and also to Grubhub's 90-day free trial period followed by a 5% transaction fee thereafter.",
    ],
    list: [
      {
        icon: validationStepUrls.icons.lock,
        text: 'Balance uses industry-standard encryption to protect your business details',
      },
      {
        icon: validationStepUrls.icons.check,
        text: 'Balance does not perform hard credit checks',
      },
    ],
  },
  inReview: {
    illustrationUrl: validationStepUrls.illustrations.inReview,
    title: 'Application in review',
    text: [
      "Balance is reviewing your application. We'll notify the administrator of this account by email when we have an update.",
      'For questions about your application, contact Balance at',
    ],
  },
  rejected: {
    illustrationUrl: validationStepUrls.illustrations.rejected,
    title: 'Account not approved by Balance',
    text: [
      'Unfortunately, your business was not approved for a corporate account. Our verification partner, Balance, made this decision based on the credit and business information you submitted.',
      "Please check your email for a final communication from Balance that offers detailed reasons for this decision, as well as steps to take if you'd like to appeal.",
      'For questions about this decision, contact Balance at',
    ],
  },
  approvedWithNetTerms: {
    illustrationUrl: validationStepUrls.illustrations.approved,
    title: ["You've been approved for a line of credit with a", 'limit'],
    text: [
      'As Balance gets to know your business better, you may qualify for increased limits. Next step: Setting up your meal credits and adding employees who can use them.',
      'If you have any questions, please contact Balance at',
    ],
  },
  approvedWithoutNetTerms: {
    illustrationUrl: validationStepUrls.illustrations.approved,
    title: 'Financial information verified',
    text: [
      'Your account is ready to use with the credit card on file, and you can still qualify for Invoicing at any time. You can now continue setting up your Grubhub for Business account. Next, you can set up your meal credits and add employees.',
      'For payment or invoicing questions, contact Balance at',
    ],
  },
} as const;

export const supportEmail = 'support@getbalance.com';
